import React from "react";
import styled from "styled-components";
import { BsCheckLg } from "react-icons/bs";
import DashboardSidebar from "../components/DashboardSidebar";

const Plans = () => {
  return (
    <>
      <DashboardSidebar>
        <PlansMain>Plans</PlansMain>
        <PlansContainer>
          <PlanCenter>
            <PlansGrid>
              <PlansCard>
                <h3>Basic</h3>
                <h4 className="free">FREE</h4>
                <PlanList>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    15 day trail
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    24/7 Chat support
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Docs, FAQ, Community Forums
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Trail Access to money manager
                    <br /> software
                  </li>
                </PlanList>
                <div className="btn">Start Free Trail</div>
              </PlansCard>
              <PlansCard>
                <h3>Business</h3>
                <h4>
                  Starting at <span>₹1500/mo</span>
                </h4>
                <PlanList>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Unlimited access
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    24/7 continuous service
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Docs, FAQ, Community Forums
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    All Access to money manager
                    <br /> software
                  </li>
                </PlanList>
                <div className="planBtn">Get Started</div>
              </PlansCard>
              <PlansCard>
                <h3>Enterprise</h3>
                <h4 className="contact">Contact Us for Pricing*</h4>
                <PlanList>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Access to Support 24/7
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Call On +91 7418529630
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Docs, FAQ, Community Forums
                  </li>
                  <li>
                    <div>
                      <BsCheckLg className="check" />
                    </div>
                    Customized modules & <br /> features as per requirements.
                  </li>
                </PlanList>
                <div className="planBtn">Contact Sales</div>
              </PlansCard>
            </PlansGrid>
          </PlanCenter>
        </PlansContainer>
      </DashboardSidebar>
    </>
  );
};

export default Plans;

const PlansMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const PlansContainer = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 15px;
  border-radius: 8px;
`;

const PlanCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlansGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

const PlansCard = styled.div`
  height: 100%;
  padding: 10px 25px;
  border-radius: 8px;
  position: relative;

  h3 {
    font-weight: 500;
    font-size: 22px;
  }
  h4 {
    font-weight: 500;
    font-size: 22px;
    margin-top: 1.2rem;
    color: rgb(0, 30, 43);

    span {
      font-weight: 600;
      font-size: 25px;
    }
  }
  .free {
    color: blue !important;
  }
  .contact {
    color: rgb(0, 104, 74) !important;
  }
  .btn {
    position: absolute;
    bottom: 3%;
    left: 10%;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    width: 85%;
    text-align: center;
    padding: 5px 10px;
    border: 1px solid rgb(136, 147, 151);
    border-radius: 6px;
    background-color: rgb(249, 251, 250);
    color: rgb(0, 30, 43);
    font-size: 15px;
    line-height: 20px;
    font-weight: 500;
    margin-top: 17px;
    margin-left: -4px;
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .planBtn {
    position: absolute;
    bottom: 3%;
    left: 10%;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    width: 85%;
    text-align: center;
    padding: 5px 10px;
    border: 1px solid rgb(136, 147, 151);
    border-radius: 6px;
    background-color: #005800;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    font-weight: 500;
    margin-top: 17px;
    margin-left: -4px;
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;

const PlanList = styled.ul`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;
  list-style: none;
  margin-bottom: 3rem;

  li {
    color: rgb(0, 30, 43);
    margin: 0px 0px;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: yellowgreen;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      margin-right: 7px;
      margin-bottom: -7px;

      .check {
        font-size: 15px;
        color: #fff;
      }
    }
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    li {
      margin-bottom: 1rem;
    }
  }
`;
